import { Instance, types } from "mobx-state-tree";
import { sharedModelsGetter, sharedServicesGetters } from "../shared/storeUtils";
import { ProfanityEventHandler } from "./eventHandler";
import { matchProfanity } from "./validator";

export const ProfanityStore = types
  .model("ProfanityStore", {
    profanities: types.array(types.string)
  })
  .views(sharedServicesGetters)
  .views(sharedModelsGetter)
  .actions((self) => {
    const actions = {
      setProfanities(profanities: Array<string>) {
        self.profanities.replace(profanities.map(profanity => profanity.toLowerCase()));
      },

      matchProfanity(text: string) {
        return matchProfanity(self.profanities, text);
      },

      isProfanityIncludedInText(profanity: string, text: string) {
        return matchProfanity([profanity], text);
      }
    };

    return actions;
  })
  .actions((self) => {
    const handlerName = "ProfanityStoreEventHandler";
    const actions = {
      afterCreate() {
        self.sharedEventListener.addGlobalListener(
          new ProfanityEventHandler(() => self as IProfanityStore, handlerName)
        );
      },

      beforeDestroy() {
        self.sharedEventListener.removeGlobalListener(handlerName);
      }
    };

    return actions;
  });

export interface IProfanityStore extends Instance<typeof ProfanityStore> { }
